var WidgetData = new Class({
	merge_element_data_to_options: function(_element, options) {
		var data = {};
		[].forEach.call(_element.attributes, function(attr) {
			if (/^data-/.test(attr.name)) {
				var camelCaseName = attr.name.substr(5).replace(/-(.)/g, function ($0, $1) {
					// return $1.toUpperCase();
					return '_'+$1;
				});
				data[camelCaseName] = attr.value;
			}
		});
		
		return Object.merge(options, data);		
	}
});